<template>
  <CFooter :fixed="false">
    <div>
      <span>Dracio - Asset tracking</span>
      <span class="ml-1">&copy; {{new Date().getFullYear()}}</span>
    </div>
    <div class="ml-auto">
      <span class="mr-1">Powered by</span>
      <a href="https://www.corryn.net" target="_blank">Corryn, s.r.o.</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
